import adminRequest from '@/utils/h5-admin-request'
import { uploadH5AdminImage } from '@/api/h5-admin-redbook'

const PREFIX = '/signstore/h5admin/sealStock'

export { uploadH5AdminImage }

export function fetchSealRules(params) {
  return adminRequest.get(PREFIX + '/rules', { params })
}

export function fetchEnabledSealRules() {
  return adminRequest.get(PREFIX + '/rules/enabledList')
}

export function createSealRule(data) {
  return adminRequest.post(PREFIX + '/rules', data)
}

export function updateSealRule(data) {
  return adminRequest.post(PREFIX + '/rules/update', data)
}

export function deleteSealRules(ids) {
  return adminRequest.post(PREFIX + '/rules/delete', ids)
}

export function fetchSealHandles(params) {
  return adminRequest.get(PREFIX + '/handles', { params })
}

export function fetchEnabledSealHandles() {
  return adminRequest.get(PREFIX + '/handles/enabledList')
}

export function updateSealHandle(data) {
  return adminRequest.post(PREFIX + '/handles/update', data)
}

export function fetchSealBases(params) {
  return adminRequest.get(PREFIX + '/bases', { params })
}

export function fetchEnabledSealBases() {
  return adminRequest.get(PREFIX + '/bases/enabledList')
}

export function createSealBase(data) {
  return adminRequest.post(PREFIX + '/bases', data)
}

export function updateSealBase(data) {
  return adminRequest.post(PREFIX + '/bases/update', data)
}

export function deleteSealBase(id) {
  return adminRequest.post(PREFIX + '/bases/delete', { id })
}

export function fetchSealSuppliers(params) {
  return adminRequest.get(PREFIX + '/suppliers', { params })
}

export function fetchEnabledSealSuppliers() {
  return adminRequest.get(PREFIX + '/suppliers/enabledList')
}

export function createSealSupplier(data) {
  return adminRequest.post(PREFIX + '/suppliers', data)
}

export function updateSealSupplier(data) {
  return adminRequest.post(PREFIX + '/suppliers/update', data)
}

export function fetchSealSupplierPrices(supplierId) {
  return adminRequest.get(PREFIX + '/suppliers/' + supplierId + '/prices')
}

export function saveSealSupplierPrice(data) {
  return adminRequest.post(PREFIX + '/suppliers/prices/save', data)
}

export function deleteSealSupplierPrice(id) {
  return adminRequest.post(PREFIX + '/suppliers/prices/delete', { id })
}

export function fetchSealPurchasePrice(params) {
  return adminRequest.get(PREFIX + '/suppliers/purchasePrice', { params })
}

export function fetchSealSkus(params) {
  return adminRequest.get(PREFIX + '/skus', { params })
}

export function fetchEnabledSealSkus(params) {
  return adminRequest.get(PREFIX + '/skus/enabledList', { params })
}

export function getOrCreateSealSku(ruleId, baseId, handleId) {
  return adminRequest.post(PREFIX + '/skus/getOrCreate', null, { params: { ruleId, baseId, handleId } })
}

export function updateSealSku(data) {
  return adminRequest.post(PREFIX + '/skus/update', data)
}

export function fetchSealSkuMovements(id) {
  return adminRequest.get(PREFIX + '/skus/' + id + '/movements')
}

export function fetchSealStockChannels() {
  return adminRequest.get(PREFIX + '/channels')
}

export function fetchSealStockInList(params) {
  return adminRequest.get(PREFIX + '/in', { params })
}

export function fetchSealStockInDetail(id) {
  return adminRequest.get(PREFIX + '/in/' + id)
}

export function createSealStockIn(data) {
  return adminRequest.post(PREFIX + '/in', data)
}

export function fetchSealStockOutList(params) {
  return adminRequest.get(PREFIX + '/out', { params })
}

export function fetchSealStockOutDetail(id) {
  return adminRequest.get(PREFIX + '/out/' + id)
}

export function createSealStockOut(data) {
  return adminRequest.post(PREFIX + '/out', data)
}

// ---------- 生产需求 ----------

export function fetchSealProduceDemands(params) {
  return adminRequest.get(PREFIX + '/produceDemands', { params })
}

export function fetchSealProduceDemandDetail(id) {
  return adminRequest.get(PREFIX + '/produceDemands/' + id)
}

export function createSealProduceDemand(data) {
  return adminRequest.post(PREFIX + '/produceDemands', data)
}

export function shipSealProduceDemand(id) {
  return adminRequest.post(PREFIX + '/produceDemands/' + id + '/ship')
}

export function receiveSealProduceDemand(data) {
  return adminRequest.post(PREFIX + '/produceDemands/receive', data)
}

export function cancelSealProduceDemand(id) {
  return adminRequest.post(PREFIX + '/produceDemands/' + id + '/cancel')
}

export function ensureSealSupplierAccessToken(supplierId) {
  return adminRequest.post(PREFIX + '/produceDemands/suppliers/' + supplierId + '/ensureAccessToken')
}

export function regenerateSealSupplierAccessToken(supplierId) {
  return adminRequest.post(PREFIX + '/produceDemands/suppliers/' + supplierId + '/regenerateAccessToken')
}

export function ensureSealStockBoardToken() {
  return adminRequest.post(PREFIX + '/board/ensureAccessToken')
}

export function regenerateSealStockBoardToken() {
  return adminRequest.post(PREFIX + '/board/regenerateAccessToken')
}


